var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTvEntertainment = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Modern-Tv-Apple--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Modern Tv Apple Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 19.5h-15a6 6 0 0 1 -4.08 -1.6 0.25 0.25 0 0 0 -0.27 0 0.25 0.25 0 0 0 -0.15 0.23v0.42A4.51 4.51 0 0 0 4.5 23h15a4.51 4.51 0 0 0 4.5 -4.5v-0.42a0.25 0.25 0 0 0 -0.15 -0.23 0.25 0.25 0 0 0 -0.27 0 6 6 0 0 1 -4.08 1.65Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 12.89 -1.4 -8.15A4.48 4.48 0 0 0 18.13 1H5.87a4.48 4.48 0 0 0 -4.43 3.74L0 12.91A4.5 4.5 0 0 0 4.5 18h15a4.5 4.5 0 0 0 4.5 -5.11ZM6.5 7.25a0.75 0.75 0 0 1 0 -1.5h4a0.75 0.75 0 0 1 0 1.5H9.25v5.25a0.75 0.75 0 0 1 -1.5 0V7.25Zm5.71 -1.44a0.75 0.75 0 0 1 1 0.4L14.77 10a0.25 0.25 0 0 0 0.46 0l1.58 -3.79a0.75 0.75 0 1 1 1.38 0.58l-2.5 6a0.75 0.75 0 0 1 -1.38 0l-2.5 -6a0.75 0.75 0 0 1 0.4 -0.98Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTvEntertainment);
export default ForwardRef;